import H from 'history'
import { BaseTheWestWeb } from './BaseTheWest.web'

import { createRenderTarget } from 'component-library/render-target'
import { ProviderChildProps } from 'component-library/navigation/FlyoutNav/FlyoutNav'
import { SiteProps } from 'thewest/Site'
import { Product } from 'component-library/__product'
import loadable from '@loadable/component'

export interface BaseTheWestProps extends SiteProps {
    location: H.Location
    flyOutProps: ProviderChildProps
    product: Product
}
const LazyBaseTheWestAmp = loadable(() =>
    import('component-library/templates/BaseTheWest/BaseTheWest.amp')
)

export const BaseTheWest = createRenderTarget<BaseTheWestProps>('BaseTheWest', {
    web: BaseTheWestWeb,
    amp: LazyBaseTheWestAmp,
    preview: BaseTheWestWeb,
    rss: BaseTheWestWeb,
})
